import { ConstraintMaxFracFleetPerAreaBase } from './base/constraint-max-frac-fleet-per-area-base';

export class ConstraintMaxFracFleetPerArea extends ConstraintMaxFracFleetPerAreaBase { }